import { render, staticRenderFns } from "./StepApproverAndComment.vue?vue&type=template&id=03e9d5f6&scoped=true"
import script from "./StepApproverAndComment.vue?vue&type=script&lang=js"
export * from "./StepApproverAndComment.vue?vue&type=script&lang=js"
import style0 from "./StepApproverAndComment.vue?vue&type=style&index=0&id=03e9d5f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e9d5f6",
  null
  
)

export default component.exports